import { api_host, api_auth, CLIENTE_ID_BCH } from '../../common/globals/constants';

const HASH = '3276bd408a114308ab00c6133fe29fb2';

/**
 * Verifica si el usuario logueado tiene acceso al módulo Métricas.
 * Retorna { autorizado: boolean, objetivos: [], total_objetivos: number }
 */
export const getClienteInfo = async (clienteId = CLIENTE_ID_BCH) => {
  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');

  const params = new URLSearchParams({
    key: api_auth,
    token,
    hash: HASH,
    clienteId,
    clienteUsuarioId: user,
  });

  const url = `${api_host}/reporte/online/indicadores/getClienteInfo/?${params.toString()}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`getClienteInfo failed: ${response.status}`);
  }

  return response.json();
};
